// extracted by mini-css-extract-plugin
export default {"text-align-center":"styles__text-align-center--iGCyp"};